import React from 'react';

import { 
  MissingDataFrameContainer, 
  MissingDataContent 
} from './styled';
import ModelSpecsMissing from './ModelSpecsMissing';
import MissingImages from './MissingImages';
import MissingDataAndImages from './MissingDataAndImages';
import { 
  StationMissingDataFrameProps,
  getCompressorModelMissingData, 
  getCompressorMissingImagesData, 
  getFlowSensorMissingData,
  transformCompressorsForModelSpecs,
  transformCompressorsForMissingImages,
  transformFlowSensorsForMissingData,
  transformFlowSensorsForMissingImages,
  shouldShowModelSpecsBucket,
  shouldShowMissingImagesBucket,
  shouldShowFlowSensorBucket
} from './StationReadinessScore.utils';

const StationMissingDataFrame: React.FC<StationMissingDataFrameProps> = ({
  onAddModelSpec,
  onAddImages,
  onAddSensorData,
  isLoading = false,
  stationData,
}) => {

  // Extract specific data for each component using the actual store data
  const compressorModelData = getCompressorModelMissingData(stationData);
  const compressorImagesData = getCompressorMissingImagesData(stationData);
  const flowSensorData = getFlowSensorMissingData(stationData);
  
  // Transform data for component props
  const modelSpecsData = transformCompressorsForModelSpecs(stationData);
  const missingImagesData = transformCompressorsForMissingImages(stationData);
  const sensorDataMissing = transformFlowSensorsForMissingData(stationData);
  const sensorImagesMissing = transformFlowSensorsForMissingImages(stationData);

  return (
    <MissingDataFrameContainer>
      <MissingDataContent>
        {shouldShowModelSpecsBucket(stationData) && (
          <ModelSpecsMissing
            percentage={compressorModelData.percentage}
            totalComponents={compressorModelData.totalComponents}
            missingComponents={compressorModelData.missingComponents}
            specs={modelSpecsData}
            onAddModelSpec={onAddModelSpec}
            isLoading={isLoading}
          />
        )}
        
        {shouldShowMissingImagesBucket(stationData) && (
          <MissingImages
            percentage={compressorImagesData.percentage}
            totalComponents={compressorImagesData.totalComponents}
            missingComponents={compressorImagesData.missingComponents}
            images={missingImagesData}
            onAddImages={onAddImages}
            isLoading={isLoading}
          />
        )}
        
        {shouldShowFlowSensorBucket(stationData) && (
          <MissingDataAndImages
            percentage={flowSensorData.percentage}
            totalSensors={flowSensorData.totalSensors}
            missingSensors={flowSensorData.missingSensors}
            sensorData={sensorDataMissing}
            sensorImages={sensorImagesMissing}
            onAddData={onAddSensorData}
            onAddImages={onAddImages}
            isLoading={isLoading}
          />
        )}
      </MissingDataContent>
    </MissingDataFrameContainer>
  );
};

export default StationMissingDataFrame;
